module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    staticStyle: {
      "margin-left": "0.5rem !important"
    },
    attrs: {
      "center": ""
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("person")]), _vm._v("Driver Management System\n        ")], 1), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-light"
    },
    on: {
      "click": _vm.openAddDriverModal
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("add")]), _vm._v("Add Driver\n          ")], 1)], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard mt-3"
  }, [_c('b-card-text', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-6 mb-3"
  }, [_c('div', {
    staticClass: "stat-card bg-primary text-white"
  }, [_c('div', {
    staticClass: "stat-icon"
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("people")])], 1), _vm._v(" "), _c('div', {
    staticClass: "stat-content"
  }, [_c('h3', [_vm._v(_vm._s(_vm.driverStats.total))]), _vm._v(" "), _c('p', [_vm._v("Total Drivers")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-6 mb-3"
  }, [_c('div', {
    staticClass: "stat-card bg-success text-white"
  }, [_c('div', {
    staticClass: "stat-icon"
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('div', {
    staticClass: "stat-content"
  }, [_c('h3', [_vm._v(_vm._s(_vm.driverStats.active))]), _vm._v(" "), _c('p', [_vm._v("Active Drivers")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-6 mb-3"
  }, [_c('div', {
    staticClass: "stat-card bg-warning text-dark"
  }, [_c('div', {
    staticClass: "stat-icon"
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("schedule")])], 1), _vm._v(" "), _c('div', {
    staticClass: "stat-content"
  }, [_c('h3', [_vm._v(_vm._s(_vm.driverStats.pending))]), _vm._v(" "), _c('p', [_vm._v("Pending Verification")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-6 mb-3"
  }, [_c('div', {
    staticClass: "stat-card bg-info text-white"
  }, [_c('div', {
    staticClass: "stat-icon"
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("credit_card")])], 1), _vm._v(" "), _c('div', {
    staticClass: "stat-content"
  }, [_c('h3', [_vm._v(_vm._s(_vm.driverStats.licensed))]), _vm._v(" "), _c('p', [_vm._v("Licensed Drivers")])])])])])])], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard mt-3"
  }, [_c('b-card-text', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "search-container"
  }, [_c('md-icon', {
    staticClass: "search-icon",
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("search")]), _vm._v(" "), _c('b-form-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "Search drivers by name, license, or contact..."
    },
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('b-form-select', {
    staticClass: "me-2",
    attrs: {
      "options": _vm.statusOptions
    },
    model: {
      value: (_vm.statusFilter),
      callback: function($$v) {
        _vm.statusFilter = $$v
      },
      expression: "statusFilter"
    }
  }), _vm._v(" "), _c('b-form-select', {
    attrs: {
      "options": _vm.typeOptions
    },
    model: {
      value: (_vm.typeFilter),
      callback: function($$v) {
        _vm.typeFilter = $$v
      },
      expression: "typeFilter"
    }
  })], 1)])])])], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard mt-3"
  }, [_c('b-card-text', [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', {
    staticClass: "table-dark"
  }, [_c('tr', [_c('th', [_vm._v("Driver Info")]), _vm._v(" "), _c('th', [_vm._v("Contact Details")]), _vm._v(" "), _c('th', [_vm._v("License Information")]), _vm._v(" "), _c('th', [_vm._v("Employment Details")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredDrivers), function(driver) {
    return _c('tr', {
      key: driver.driverId,
      staticClass: "driver-row"
    }, [_c('td', [_c('div', {
      staticClass: "driver-info"
    }, [_c('div', {
      staticClass: "driver-avatar"
    }, [_c('img', {
      attrs: {
        "src": driver.photo || '/assets/default-avatar.png',
        "alt": "Driver Photo"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "driver-details"
    }, [_c('h6', {
      staticClass: "driver-name"
    }, [_vm._v(_vm._s(driver.driverName))]), _vm._v(" "), _c('p', {
      staticClass: "driver-id"
    }, [_vm._v("ID: " + _vm._s(driver.driverId))]), _vm._v(" "), _c('b-badge', {
      staticClass: "driver-type",
      attrs: {
        "variant": driver.driverType === '1' ? 'success' : 'warning'
      }
    }, [_vm._v("\n                          " + _vm._s(driver.driverType === '1' ? 'Permanent' : 'Temporary') + "\n                        ")])], 1)])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "contact-info"
    }, [_c('p', [_c('md-icon', {
      staticClass: "text-primary me-2",
      attrs: {
        "icon": "gear-fill",
        "aria-hidden": "true"
      }
    }, [_vm._v("phone")]), _vm._v(_vm._s(driver.driverContact))], 1), _vm._v(" "), _c('p', [_c('md-icon', {
      staticClass: "text-success me-2",
      attrs: {
        "icon": "gear-fill",
        "aria-hidden": "true"
      }
    }, [_vm._v("location_on")]), _vm._v(_vm._s(driver.driverLocation || 'N/A'))], 1), _vm._v(" "), _c('p', [_c('md-icon', {
      staticClass: "text-info me-2",
      attrs: {
        "icon": "gear-fill",
        "aria-hidden": "true"
      }
    }, [_vm._v("email")]), _vm._v(_vm._s(driver.email || 'N/A'))], 1)])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "license-info"
    }, [_c('p', [_c('strong', [_vm._v("License:")]), _vm._v(" " + _vm._s(driver.license_no || 'N/A'))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Valid Until:")]), _vm._v(" " + _vm._s(_vm.formatDate(driver.licenseValidUntil)))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Class:")]), _vm._v(" " + _vm._s(driver.licenseClass || 'N/A'))])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "employment-info"
    }, [_c('p', [_c('strong', [_vm._v("Vehicle:")]), _vm._v(" " + _vm._s(driver.vehicleNumber || 'N/A'))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Joining Date:")]), _vm._v(" " + _vm._s(_vm.formatDate(driver.driverDateOfJoining)))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Experience:")]), _vm._v(" " + _vm._s(driver.driverWorkingYear || 'N/A') + " years")])])]), _vm._v(" "), _c('td', [_c('b-badge', {
      staticClass: "status-badge",
      attrs: {
        "variant": _vm.getStatusVariant(driver.isDriverActive)
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.getStatusText(driver.isDriverActive)) + "\n                    ")])], 1), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "action-buttons"
    }, [_c('b-button', {
      staticClass: "me-1",
      attrs: {
        "size": "sm",
        "variant": "outline-primary"
      },
      on: {
        "click": function($event) {
          _vm.viewDriver(driver)
        }
      }
    }, [_c('md-icon', {
      attrs: {
        "icon": "gear-fill",
        "aria-hidden": "true"
      }
    }, [_vm._v("visibility")])], 1), _vm._v(" "), _c('b-button', {
      staticClass: "me-1",
      attrs: {
        "size": "sm",
        "variant": "outline-warning"
      },
      on: {
        "click": function($event) {
          _vm.editDriver(driver)
        }
      }
    }, [_c('md-icon', {
      attrs: {
        "icon": "gear-fill",
        "aria-hidden": "true"
      }
    }, [_vm._v("edit")])], 1), _vm._v(" "), _c('b-button', {
      staticClass: "me-1",
      attrs: {
        "size": "sm",
        "variant": "outline-info"
      },
      on: {
        "click": function($event) {
          _vm.viewLicense(driver)
        }
      }
    }, [_c('md-icon', {
      attrs: {
        "icon": "gear-fill",
        "aria-hidden": "true"
      }
    }, [_vm._v("credit_card")])], 1), _vm._v(" "), _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-danger"
      },
      on: {
        "click": function($event) {
          _vm.deleteDriver(driver)
        }
      }
    }, [_c('md-icon', {
      attrs: {
        "icon": "gear-fill",
        "aria-hidden": "true"
      }
    }, [_vm._v("delete")])], 1)], 1)])])
  }))])])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bf80420","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/driverMaster/DriverManagement.vue
// module id = 2769
// module chunks = 0